import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const abortInstallFirmwareUseCase = async (update_id: string) => {
  try {
    const state = store.getState();

    const namespace = state?.yourSlice?.authContext?.customerNamespace;
    const source_id =
      store.getState().yourSlice.connectionView.source.source_id;

    const response = await apiUseCases.getAbortInstall(
      namespace,
      update_id,
      source_id,
    );

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to abort firmware installation")
        .message,
    };
  }
};
